import App from "./components/App.svelte";
import * as Sentry from "@sentry/browser";
import './assets/fonts/fonts.css';
import './styles.css';
import './auth0.css';

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  environment: process.env.SENTRY_ENV
});

const app = new App({
  target: document.body
});

export default app;
